import React from "react";
import classes from "./style.module.scss";
import cx from "classnames";
import CircleTimer from "../../../components/circleTimer";
import Person from "../components/person";
import _ from "lodash";
import Host from "../../../assets/images/tot/Host-2.png";
import Roundimg from "../../../assets/images/tot/Round.svg";

const Round = ({ count, time, screenParams, users, activeGuesser }) => {

  const preGuessLabel = _.get(
    screenParams,
    "tot.preguess_guesser_label",
    "Guesser"
  );
  const preGuessText = _.get(
    screenParams,
    "tot.preguess_text",
    "The round is about to start!"
  );
  console.log(count , time , "CircleTimerCircleTimerCircleTimer")
  return (
    <div className="tot-round">
      <div className="round-start-text">
        {/* <p className={cx(classes.roundStart)}>{preGuessText}</p> */}
        <img src={Roundimg} alt="Round" />
      </div>
      <div className="tot-round-content">
        <div className="text-center d-flex flex-column justify-content-end cardwidth">
          <Person activeGuesser={activeGuesser} />
          {/* <p className={cx("text-yellow", classes.roundTitle)}>
            {preGuessLabel}
          </p> */}
        </div>
        <div className="timer-circle">
          <CircleTimer tot count={count} time={time} />
        </div>

        <div className="inner-host">
          <img src={Host} alt="Host" />
        </div>
      </div>
    </div>
  );
};

export default Round;
